export const MARKDOWN = "markdown";
export const TEXT_HTML = "text/html";



// WEBPACK FOOTER //
// ./src/constants/contentTypes.js